import { useEffect } from 'react';
import { throwErrorForDev } from '@zocdoc-frontend-common/utils-react';
import {
    isProductionBuild,
    isNullOrEmptyString,
    throwIfAllNullOrEmptyStrings,
    throwIfNotFunction,
} from '@zocdoc-mezzanine/internal-shared';

const supportedTypes = ['text', 'email', 'password', 'tel', 'number', 'url'];

/**
 * Throws an error if one or more props are invalid.
 * This will no-op on Production builds.
 * @param {*} props - props to validate
 */
export default function usePropValidation({
    labelText,
    id,
    ariaLabel,
    ariaLabelledby,
    ariaDescribedby,
    onChange,
    type,
}) {
    useEffect(() => {
        if (isProductionBuild()) {
            return;
        }

        throwIfAllNullOrEmptyStrings(
            [labelText, ariaLabel, ariaLabelledby, ariaDescribedby],
            'If you do not supply a labelText prop, you must supply one or more of the following props: ariaLabel, ariaLabelledby or ariaDescribedby'
        );

        if (!isNullOrEmptyString(labelText) && isNullOrEmptyString(id)) {
            throwErrorForDev(
                'If you supply the labelText prop, you must also supply the id prop'
            );
        }

        throwIfNotFunction(onChange, 'onChange prop must be set.');

        if (
            !isNullOrEmptyString(type) &&
            !supportedTypes.includes(type.toLowerCase())
        ) {
            throwErrorForDev(
                `If you supply the type prop, we only support the following types: ${supportedTypes.join(
                    ', '
                )}`
            );
        }
    }, [
        ariaDescribedby,
        ariaLabel,
        ariaLabelledby,
        id,
        labelText,
        onChange,
        type,
    ]);
}
